import { Img } from "components";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
// import { useSpotlight } from 'react-spotlight-tour';
import { useSpotlight } from "../components/SpotLight";
import BhashaniVideo from "../components/BhashaniVideo";
import CommunicationModal from "../components/CommunicationModal";
import Stepper from "../components/Stepper";
import axios from "axios";
import { Button } from "components/Button";
import * as ModalR from 'react-modal';
import AvatarVideo from "../components/AvatarVideo";
import { useGlobalState } from "components/GlobalState";
import Wrapper from "../components/Wrapper";
import { languageObject, API_HOST } from "utils";
import OTPModal from "./OTPModal";
import SuccessModal from "./SuccessModal";

function extractKeysAndValues(dataArray) {
    const keys = [];
    const values = [];

    dataArray.forEach(obj => {
        const [key, value] = Object.entries(obj)[0]; // get the first key-value pair
        keys.push(Number(key));
        values.push(value);
    });

    return { keys, values };
}

const customStylesRefer = {
    content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
        width: "50rem", // Adjusted for responsiveness
        maxWidth: "90%", // Added to maintain a max width
        minHeight: "8rem",
        borderRadius: "1em",
        boxShadow: "0px 16px 32px 4px rgba(0, 0, 0, 0.15)",
        padding: "10px 0px",
        border: "0px",
    },
    overlay: {
        background: "rgba(0, 0, 0, 0.4)",
        zIndex: "999",
    },
    "@media (min-width: 768px)": {
        content: {
            width: "75%", // Adjusted for tablet view
        },
    },
    "@media (min-width: 1024px)": {
        content: {
            width: "55rem", // Original width for desktop view
        },
    },
};


const customStylesAskModal = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        width: '30rem',
        maxWidth: '80%',
        minHeight: '10rem',
        borderRadius: '1.5em',
        boxShadow: '0px 16px 32px 4px rgba(0, 0, 0, 0.15)',
        padding: '1.3em',
    },
    overlay: {
        background: 'rgba(0, 0, 0, 0.4)',
        zIndex: 999
    },
};


const videoLinks = [
    { url: "https://soomuch.blob.core.windows.net/data-soomuch/DemoContent/AvatarVideos/demo-comm-1.mp4" }
]

const handleCopyClick = async (textToCopy) => {
    try {
        await navigator.clipboard.writeText(textToCopy);
    } catch (err) {
        console.error('Failed to copy: ', err);
    }
};

const Communication = () => {
    // const videoRef = useRef(null);
    const intervalRef = useRef(null);
    const { videoReplayOnPageLoad, language } = useGlobalState();

    const [dynamicVideoLink, setDynamicVideoLink] = useState("");
    const [currentSource, setCurrentSource] = useState<any>("");
    const [communicationModal, setCommunicationModal] = useState({ display: false, DATA: {} });

    const [confirmationModal, setConfirmationModal] = useState({ display: false, data: {} });
    const [formLoader, setFormLoader] = useState(false);
    const [demoCampaignID, setDemoCampaignID] = useState<any>({});
    const [successModal, setSuccessModal] = useState<any>(false);

    const form_data = JSON.parse(sessionStorage.getItem('form_data')) || {};

    // const step1Ref = useSpotlight("");
    // const step2Ref = useSpotlight("");
    // const step3Ref = useSpotlight("");

    const genrateDATA = () => {
        let demoData: any = '';

        try {
            console.log("checking");
            demoData = JSON.parse(sessionStorage.getItem('demo_data')) || "";
        } catch (err) {
            console.log("err ", err);
        }
        return demoData
    }

    const handleTypeSelection = (source) => {
        setTheSource(source);
        setTimeout(() => {
            checkAndSubmit(source)
        },10);
    }

    const setTheSource = (source = "COMM") => {
        setCurrentSource(currentSource => source);
        if (!genrateDATA()?.DEMO_CAMPAIGN_ID && !JSON.parse(sessionStorage.getItem("demo_data"))?.DEMO_CAMPAIGN_ID) {
            sessionStorage.setItem('demo_data', JSON.stringify({
                SOURCE: source,
                OTP: "",
                IDS: [],
                ALREADY_PLAYED: []
            }));
        } else {
            setDemoCampaignID({ ...genrateDATA(), SOURCE: source })
            sessionStorage.setItem('demo_data', JSON.stringify({
                ...genrateDATA(),
                SOURCE: source,
            }));
        }
    }

    // useEffect(() => {
    //     const checkAndRequest = async () => {
    //         const isAllow = !!JSON.parse(sessionStorage.getItem('demo_data'))?.IDS?.length;
    //         if (isAllow) {
    //             // Your API request logic here
    //             const query = JSON.parse(sessionStorage.getItem('demo_data'))?.IDS?.map(id => `ids=${id}`).join("&");
    //             const response = await axios.get(`${API_HOST}/master/demoCampaignDetail/callStatus?${query}`);
    //             if ([200, 201]?.includes(response?.data?.code)) {
    //                 handleVideoSaving(response?.data?.data.filter((item:any) => !!item?.[genrateDATA()?.IDS?.find(key => item[key])]))
    //             }
    //         } else {
    //             console.log('isAllow is false, stopping interval');
    //             clearInterval(intervalRef.current);
    //             intervalRef.current = null;
    //         }
    //     };

    //     // Start the interval if isAllow is true
    //     if (!!JSON.parse(sessionStorage.getItem('demo_data'))?.IDS?.length && !intervalRef.current) {
    //         intervalRef.current = setInterval(checkAndRequest, 6000);
    //     }

    //     // Watch for changes in sessionStorage
    //     const storageListener = () => {
    //         if (!!JSON.parse(sessionStorage.getItem('demo_data'))?.IDS?.length && !intervalRef.current) {
    //             intervalRef.current = setInterval(checkAndRequest, 6000);
    //         } else if (!JSON.parse(sessionStorage.getItem('demo_data'))?.IDS?.length && intervalRef.current) {
    //             clearInterval(intervalRef.current);
    //             intervalRef.current = null;
    //         }
    //     };

    //     window.addEventListener('storage', storageListener);

    //     return () => {
    //         clearInterval(intervalRef.current);
    //         window.removeEventListener('storage', storageListener);
    //     };
    // }, []);

    useEffect(() => {
        const checkAndRequest = async () => {
            const isAllow = !!demoCampaignID?.IDS?.length;
            if (isAllow) {
                const query = demoCampaignID.IDS.map(id => `ids=${id}`).join("&");
                const response = await axios.get(`${API_HOST}/master/demoCampaignDetail/callStatus?${query}&lang=${languageObject?.[language]}`);
                if ([200, 201].includes(response?.data?.code)) {
                    handleVideoSaving(
                        response?.data?.data.filter((item: any) =>
                            !!item?.[demoCampaignID?.IDS?.find(key => item[key])]
                        )
                    );
                }
            } else {
                clearInterval(intervalRef.current);
                intervalRef.current = null;
            }
        };

        if (!!demoCampaignID?.IDS?.length && !intervalRef.current) {
            intervalRef.current = setInterval(checkAndRequest, 6000);
        }

        return () => {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [demoCampaignID?.IDS?.join(",")]);

    useEffect(() => {
        if (!genrateDATA()?.DEMO_CAMPAIGN_ID && !JSON.parse(sessionStorage.getItem("demo_data"))?.DEMO_CAMPAIGN_ID) {
            setTheSource();
        } else {
            setCurrentSource(genrateDATA()?.SOURCE)
            setDemoCampaignID(genrateDATA())
        }
    }, []);

    const handleSubmit = async (values) => {
        try {
            setFormLoader(true);
            if (demoCampaignID?.DEMO_CAMPAIGN_ID) {
                const payloadValue: any = {
                    ...demoCampaignID,
                    OTP: values?.OTP,
                    SALES_USER_OTP: values?.SALES_USER_OTP,
                    IDS: undefined,
                    ALREADY_PLAYED: undefined
                };

                const campaginDetailResponse = await axios.post(`${API_HOST}/master/demoCampaignDetail/insert`, payloadValue);

                sessionStorage.setItem('demo_data', JSON.stringify({
                    ...payloadValue,
                    IDS: campaginDetailResponse?.data?.data?.ids,
                    ALREADY_PLAYED: []
                }));
                sessionStorage.setItem('form_data', JSON.stringify(values));
                if ([200, 201]?.includes(campaginDetailResponse?.data?.code)) {
                    setSuccessModal(successModal => ({ key: "success", message: campaginDetailResponse?.data?.message }));
                } else {
                    throw new Error(campaginDetailResponse?.data?.message)
                }
            }
        } catch (err) {
            console.log(err);
            setSuccessModal(successModal => ({ key: "error", message: err?.message }));
        } finally {
            setFormLoader(false);
            setConfirmationModal({ display: false, data: {} });
        }

    };

    const checkAndSubmit = async (source?) => {
        const form_data = JSON.parse(sessionStorage.getItem('form_data')) || {};
        try {
            setFormLoader(true);
            if (!!form_data?.MOBILE_NUMBER) {
                const isDataIsAlreadyThere = await axios.get(`${API_HOST}/master/demoCampaign/check?mobile_number=${form_data?.MOBILE_NUMBER}&source=${source || currentSource || form_data?.SOURCE}`);
                if (isDataIsAlreadyThere?.data?.data?.exists) {
                    setConfirmationModal({ display: true, data: form_data })
                }/*  else if (!!form_data?.MOBILE_NUMBER) {
                    handleSubmit(form_data);
                }  */else {
                    setCommunicationModal({ display: true, DATA: genrateDATA() || JSON.parse(sessionStorage.getItem("demo_data")) })
                }
            } else {
                setCommunicationModal({ display: true, DATA: genrateDATA() || JSON.parse(sessionStorage.getItem("demo_data")) })
            }
        } catch (err) {
            setSuccessModal(successModal => ({ key: "error", message: err?.message }));
        } finally {
            setFormLoader(false);
        }
    }

    const getSourceNames = () => {
        return currentSource === "COMM" ? "Daily Updates" : currentSource;
    }

    const handleCommunicationModal = (e) => {
        setCommunicationModal(e)
        if (!!genrateDATA()?.DEMO_CAMPAIGN_ID && !!JSON.parse(sessionStorage.getItem("demo_data"))?.DEMO_CAMPAIGN_ID) {
            setDemoCampaignID(demoCampaignID => ({ ...genrateDATA(), SOURCE: currentSource || form_data?.SOURCE }))
            // window.location.reload()
        }
    }

    const handleVideoSaving = (videoURL: any = "") => {
        if (typeof (videoURL) === "string") {
            setDynamicVideoLink(dynamicVideoLink => videoURL)
        } else if (Array.isArray(videoURL) && !!videoURL?.length) {
            const result = extractKeysAndValues(videoURL);
            const removeKeys = genrateDATA()?.IDS?.filter(item => !result?.keys?.includes(+item))
            setDynamicVideoLink(dynamicVideoLink => !!removeKeys?.length ? result?.values?.[0] : "https://soomuch.blob.core.windows.net/data-soomuch/DemoContent/AvatarVideos/comm-demo-end.mp4")
            sessionStorage.setItem('demo_data', JSON.stringify({
                ...genrateDATA(),
                IDS: removeKeys
            }));
            setDemoCampaignID(demoCampaignID => ({ ...genrateDATA(), IDS: removeKeys }))
        }
    }

    const disableIT = (!!demoCampaignID?.IDS?.length) ? "Call is going on" : "";

    return (
        <Wrapper
            title={"Communications Made Easy"}
            description="🚫 Say NO to outdated methods that cause delays, confusion, and lost opportunities."
            descriptionSize="text-[2.5vh]"
            videoLinks={<AvatarVideo
                videoLinks={videoLinks}
                dynamicVideoLink={dynamicVideoLink}
                handleDynamicVideoLink={() => setDynamicVideoLink("")}
                videoLoader={"https://soomuch.blob.core.windows.net/data-soomuch/DemoContent/AvatarVideos/rani-thumbnail.png"}
                dontPlayMainVideoOnEveryRender
            />}
            disableNavigation={disableIT}
            body={<>
                {!!successModal?.key && <SuccessModal
                    isOpen={successModal}
                    onRequestClose={() => {
                        setSuccessModal(false)
                    }}
                />}
                {!!communicationModal?.display && <CommunicationModal
                    showModal={communicationModal}
                    customStyles={customStylesRefer}
                    setshowModal={(e) => handleCommunicationModal(e)}
                    handleVideoSaving={e => handleVideoSaving(e)}
                    externalSource={currentSource}
                />}
                {!!confirmationModal.display && <ModalR
                    isOpen={confirmationModal.display}
                    contentLabel="Example Modal"
                    style={customStylesAskModal}
                >
                    <div className="flex justify-between">
                        <h1 className="font-bold text-xl">Confirmation</h1>
                        <button onClick={() => setConfirmationModal({ display: false, data: {} })}>
                            <Img src="/images/Close.svg" alt="close" className="h-8" />
                        </button>
                    </div>
                    <p className="text-medium text-md text-neutral-70 my-[1.5em]">
                        The {getSourceNames()} demo for this number has already been completed. Are you sure you want to proceed with another demonstration?
                    </p>
                    <div className="flex justify-end">
                        <div className="flex gap-2">
                            <Button
                                size="sm"
                                type="button"
                                className="font-manropeSB rounded-lg"
                                onClick={() => {
                                    setConfirmationModal({ display: false, data: {} });
                                }}
                            >
                                No
                            </Button>
                            {formLoader ? <div>
                                <Img src="images/loader.gif" alt="loader" className="h-10" />
                            </div> : <button
                                onClick={() => {
                                    handleSubmit(confirmationModal?.data);
                                }}
                                title="Send OTP"
                                type="button"
                                className={`bg-smd_blue-normal text-[white] py-2 px-4 rounded-2xl`}>
                                Yes
                            </button>}
                        </div>
                    </div>
                </ModalR>}
                <div className="font-inter text-center space-y-4">
                    <h2 className="text-smd_blue-normal font-manropeB text-[3vh]">Inspired by PM Narendra Modi’s Vision</h2>
                    <p className={`text-[2vh]`}><span className="font-manropeB text-[black]">Our Prime Minister launched Bhashini </span>to empower Indians to communicate in their regional languages. we embrace this <br />mission by ensuring seamless communication <span className="font-manropeB">in parents' preferred language.</span></p>
                </div>
                <div className="grid grid-cols-12 gap-4 w-full">
                    <div className="col-span-5">
                        <BhashaniVideo />
                    </div>
                    <div className="font-inter col-span-7 flex flex-col justify-center items-center gap-y-6 border-2 border-smd_blue-light rounded-xl p-4">
                        <div className="text-center space-y-2">
                            <h2 className="text-smd_blue-dark font-manropeB text-[3vh]">Experience Auto Connect – Our 3 way Communication with 15+ modules</h2>
                            <p className="text-[2vh]">{!!demoCampaignID?.IDS?.length ? <span className="font-bold text-[red]">{`${demoCampaignID?.IDS?.length} Call${demoCampaignID?.IDS?.length > 1 ? "s" : ""} Remaining....`}</span> : "See how automated calls/sms/whatsApp bridge the communication gap."}</p>
                        </div>
                        <div className="flex justify-center gap-4">
                            <div className="bg-[#F5F5F5] rounded-xl p-[2vh] shadow-lg flex flex-col items-center gap-[2vh]">
                                <Img src="images/soomuch-demo/DailyUpdates.svg" alt="DailyUpdates" className="h-10" />
                                <p className="text-[2vh]">Daily Updates</p>
                                 <button 
                                    type="button" 
                                    className={`text-[2vh] font-light flex gap-2 items-center ${!!disableIT ? "bg-[lightgray]" : "bg-smd_blue-dark"} text-[white] rounded-lg py-2 px-4`} 
                                    onClick={() => handleTypeSelection("COMM")}
                                    disabled={!!disableIT}
                                    title={disableIT}
                                >
                                    Daily Updates Demo
                                </button>
                            </div> 
                            <div className="bg-[#F5F5F5] rounded-xl p-[2vh] shadow-lg flex flex-col items-center gap-[2vh]">
                                <Img src="images/soomuch-demo/FeeFollowUps.svg" alt="FeeFollowUps" className="h-10" />
                                <p className="text-[2vh]">Fee Follow Ups</p>
                                 <button 
                                    type="button" 
                                    className={`text-[2vh] font-light flex gap-2 items-center ${!!disableIT ? "bg-[lightgray]" : "bg-smd_blue-dark"} text-[white] rounded-lg py-2 px-4`} 
                                    onClick={() => handleTypeSelection("FEE")}
                                    disabled={!!disableIT}
                                    title={disableIT}
                                >
                                    Fee Follow Up Demo
                                </button>
                            </div>
                        </div>
                        {/* <div className="w-full flex flex-col items-center gap-4 text-[2vh]">
                            <div className="flex items-center gap-4">
                                <button 
                                    type="button" 
                                    className={`flex gap-2 items-center border border-[black] rounded-xl py-2 px-4 ${currentSource === "COMM" ? "bg-smd_blue-dark text-[white]" : ""}`} 
                                    onClick={() => setTheSource("COMM")}
                                >
                                    <div className={`rounded-full h-[2.5vh] w-[2.5vh] ${currentSource === "COMM" ? "border border-[white] bg-smd_golden-bell" : "border border-[black]"}`} />
                                    Daily Updates
                                </button>
                                <button 
                                    type="button" 
                                    className={`flex gap-2 items-center border border-[black] rounded-xl py-2 px-4 ${currentSource === "FEE" ? "bg-smd_blue-dark text-[white]" : ""}`} 
                                    onClick={() => setTheSource("FEE")}
                                >
                                    <div className={`rounded-full h-[2.5vh] w-[2.5vh] ${currentSource === "FEE" ? "border border-[white] bg-smd_golden-bell" : "border border-[black]"}`} /> Fee Follow Up
                                </button>
                            </div>
                            {formLoader ? <div>
                                <Img src="images/loader.gif" alt="loader" className="h-10" />
                            </div> : <button onClick={() => checkAndSubmit()} type="button" className={`text-[2.5vh] py-4 px-6 bg-smd_blue-dark font-thin text-gray-200 rounded-xl ${false ? "cursor-progress" : ""}`}>
                                Experience Live Demo
                            </button>}
                            <p className="text-[2vh] text-smd_blue-dark">{!!demoCampaignID?.IDS?.length ? `${demoCampaignID?.IDS?.length} Call${demoCampaignID?.IDS?.length > 1 ? "s" : ""} Remaining....` : "Takes less than 30 seconds"}</p>
                        </div> */}
                        <p className="flex gap-1 text-[2vh]">
                            Save this number
                            <span className="text-smd_blue-dark underline decoration-dotted font-manropeB tracking-widest">+91 8065195555</span>
                            <button type="button" onClick={() => handleCopyClick("+918065195555")}>
                                <Img src="images/soomuch-demo/copy.svg" className="h-5" />
                            </button>
                            you’ll get a call from it soon!
                        </p>
                    </div>
                </div>
            </>}
        />
        // <div className="flex justify-center min-h-screen bg-[url(/public/images/soomuch-demo/background.svg)] bg-no-repeat bg-cover bg-center">
        //     {!!communicationModal?.display && <CommunicationModal
        //         showModal={communicationModal}
        //         customStyles={customStylesRefer}
        //         setshowModal={(e) => handleCommunicationModal(e)}
        //         handleVideoSaving={e => handleVideoSaving(e)}
        //     />}
        //     {!!confirmationModal.display && <ModalR
        //         isOpen={confirmationModal.display}
        //         contentLabel="Example Modal"
        //         style={customStylesAskModal}
        //     >
        //         <div className="flex justify-between">
        //             <h1 className="font-bold text-xl">Confirmation</h1>
        //             <button onClick={() => setConfirmationModal({ display: false, data: {} })}>
        //                 <Img src="/images/Close.svg" alt="close" className="h-8" />
        //             </button>
        //         </div>
        //         <p className="text-medium text-md text-neutral-70 my-[1.5em]">
        //             The {getSourceNames()} demo for this number has already been completed. Are you sure you want to proceed with another demonstration?
        //         </p>
        //         <div className="flex justify-end">
        //             <div className="flex gap-2">
        //                 <Button
        //                     size="sm"
        //                     type="button"
        //                     className="font-manropeSB rounded-lg"
        //                     onClick={() => {
        //                         setConfirmationModal({ display: false, data: {} });
        //                     }}
        //                 >
        //                     No
        //                 </Button>
        //                 {formLoader ? <div>
        //                     <Img src="images/loader.gif" alt="loader" className="h-10" />
        //                 </div> : <button
        //                     onClick={() => {
        //                         handleSubmit(confirmationModal?.data);
        //                     }}
        //                     title="Send OTP"
        //                     type="button"
        //                     className={`bg-smd_blue-normal text-[white] py-2 px-4 rounded-2xl`}>
        //                     Yes
        //                 </button>}
        //             </div>
        //         </div>
        //     </ModalR>}
        //     <div className="container font-manrope p-7 flex flex-col justify-between w-full">
        //         <div className="flex">
        //             <div className="grid grid-cols-12 gap-4 w-full">
        //                 <div className="col-span-2"><Img src="images/soomuch-demo/logo.svg" /></div>
        //                 <div className="text-center self-end space-y-2 col-span-8">
        //                     <h1 className="font-raveo text-smd_blue-normal text-4xl font-[1000] leading-[120%] tracking-[-1%]">Communications Made Easy</h1>
        //                     <p className="text-sm">🚫 Say NO to outdated methods that cause delays, confusion, and lost opportunities.</p>
        //                 </div>
        //                 <div className="flex justify-end col-span-2">
        //                     <AvatarVideo
        //                         videoLinks={videoLinks}
        //                         dynamicVideoLink={dynamicVideoLink}
        //                         handleDynamicVideoLink={() => setDynamicVideoLink("")}
        //                         videoLoader={"https://soomuch.blob.core.windows.net/data-soomuch/DemoContent/AvatarVideos/rani-thumbnail.png"}
        //                         dontPlayMainVideoOnEveryRender
        //                     />
        //                 </div>
        //             </div>
        //         </div>
        //         <div className="text-center space-y-2">
        //             <h2 className="text-smd_blue-normal font-manropeSB text-xl">Inspired by PM Narendra Modi’s Vision</h2>
        //             <p className={`tracking-widest text-md`}><span className="font-manropeSB">Our Prime Minister launched Bhashini </span>to empower Indians to communicate in their regional languages. we embrace this <br />mission by ensuring seamless communication <span className="font-manropeSB">in parents' preferred language.</span></p>
        //         </div>
        //         <div className="grid grid-cols-12 gap-4 w-full">
        //             <div className="col-span-5">
        //                 <BhashaniVideo />
        //             </div>
        //             <div className="col-span-7 flex flex-col justify-center items-center gap-y-6 border-2 border-smd_blue-light rounded-xl p-4">
        //                 <div className="text-center space-y-2">
        //                     <h2 className="tracking-wide text-smd_blue-dark font-manropeSB text-xl">Experience Auto Connect – Our 3 way Communication</h2>
        //                     <p className="text-sm">See how automated calls/sms/whatsApp bridge the communication gap.</p>
        //                 </div>
        //                 <div className="w-full flex flex-col items-center gap-4">
        //                     <div className="flex items-center gap-4">
        //                         <button type="button" className={`text-xs border border-[black] rounded-xl py-1 px-2 ${currentSource === "COMM" ? "bg-smd_blue-dark text-[white]" : ""}`} onClick={() => setTheSource("COMM")}>Daily Updates</button>
        //                         <button type="button" className={`text-xs border border-[black] rounded-xl py-1 px-2 ${currentSource === "FEEDBACK" ? "bg-smd_blue-dark text-[white]" : ""}`} onClick={() => setTheSource("FEEDBACK")}>Feedback</button>
        //                         <button type="button" className={`text-xs border border-[black] rounded-xl py-1 px-4 ${currentSource === "FEE" ? "bg-smd_blue-dark text-[white]" : ""}`} onClick={() => setTheSource("FEE")}>Fee Follow Up</button>
        //                     </div>
        //                     {formLoader ? <div>
        //                         <Img src="images/loader.gif" alt="loader" className="h-10" />
        //                     </div> : <button disabled={!videoReplayOnPageLoad?.includes(window.location.pathname)} onClick={() => checkAndSubmit()} type="button" className={`py-2 px-6 bg-smd_blue-dark font-normal text-[white] rounded-xl ${!videoReplayOnPageLoad?.includes(window.location.pathname) ? "cursor-progress" : ""}`}>
        //                         Experience Live Demo
        //                     </button>}
        //                     <p className="text-sm text-smd_blue-dark">Takes less than 30 seconds</p>
        //                 </div>
        //                 <p className="flex gap-1 text-sm">
        //                     Save this number
        //                     <span className="text-smd_blue-dark underline decoration-dotted font-manropeSB tracking-widest">+91 8065195555</span>
        //                     <button type="button" onClick={() => handleCopyClick("+918065195555")}>
        //                         <Img src="images/soomuch-demo/copy.svg" className="h-5" />
        //                     </button>
        //                     you’ll get a call from it soon!
        //                 </p>
        //             </div>
        //         </div>
        //         <Stepper />
        //     </div>
        // </div>
    );
}

export default Communication;